import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';

import { BetaalverzoekModule } from './betaalverzoek.module';

// @ts-ignore: Needs to be ignored so the typescript compiler replaces CONFIGURATION
export const configuration: string = CONFIGURATION;

if (configuration !== 'development') {
    enableProdMode();
}

registerLocaleData(localeNl, 'nl');

platformBrowserDynamic()
    .bootstrapModule(BetaalverzoekModule, { applicationProviders: [provideZoneChangeDetection()] }) // eslint-disable-next-line no-console
    .catch((err) => console.log(err)); // NOSONAR
